import Service from "./Service";
import {
  BtripContraryEntity,
  BtripTaskEntity,
  BtripTextEntity,
  ExtraInfoEntity,
  ProjectEntity,
  TripFlowEntity,
  TripLimitEntity,
  TripPriceEntity,
  TripRoleEntity,
  TripRuleEntity,
  TaskListEntity,
  cityLabelList,
} from "../model/Btrip";
import { PageList } from "@/model/system";
class btripServcice extends Service {
  getBtripTexts(id: string) {
    return this.get<BtripTextEntity[]>(`/BtripText/BtripTexts/${id}`);
  }
  getBtripTask(data: BtripTaskEntity) {
    return this.post<BtripTaskEntity>(`/BtripTask/GetBtripTask`, data);
  }
  getTripRule(data: TripRuleEntity) {
    return this.post<TripRuleEntity>(`/TripRule/GetTripRule`, data);
  }
  getBtripTextList(data: TripRuleEntity) {
    return this.post<PageList<TripRuleEntity>>(`/BtripText/list`, data);
  }
  saveTripRejectReason(data: BtripTaskEntity) {
    return this.post<number>(`/BtripTask/Update`, data);
  }
  getTripFlowDetail(id: string) {
    return this.get<TripFlowEntity>(`/TripFlow/Details/${id}`);
  }
  getProjectList(data: ProjectEntity) {
    return this.post<PageList<ProjectEntity>>(`/Project/List`, data);
  }
  getTasklist(data: TaskListEntity) {
    return this.post<PageList<TaskListEntity>>(`/Task/list`, data)
  }
  getBtripProjectList(data: ProjectEntity){
    return this.post<PageList<TaskListEntity>>(`/project/list`, data)
  }
  saveTask(data: TaskListEntity) {
    return this.post<TaskListEntity>(`/Task/save`, data)
  }
  getTripCityLabelList(data:{PageNo:number,PageSize:number}) {
    return this.post<PageList<cityLabelList>>(`/TripCityLabel/List`,data);
  }
  SearchUserProjects(data: ProjectEntity) {
    return this.post<ProjectEntity[]>(`/Project/SearchUserProjects`, data);
  }
}
export default new btripServcice("btrip");
